import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JwtParserService {

  constructor() {}

  parseJwt(jwtToken: string) {
    const base64Url = jwtToken.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  }

}
